
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import '../css/LeadershipTable.css';
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  ToggleButton,
  ToggleButtonGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { API_BASE_URL } from "../../../config/config";
import { useSalesContext } from "../../../Pages/SalesContext";

const selectStyles = {
  maxWidth: 120,
  height: 22,
  borderRadius: "1px",
  borderWidth: "1px",
  gap: "4px",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  textTransform: "uppercase",
  border: "1px solid #00008B",
  padding: "0",
  "& .MuiSelect-select": {
    width: "100%",
    textTransform: "uppercase",
    textOverflow: "clip",
    whiteSpace: "nowrap",
    overflow: "hidden",
    padding: "14px",
    paddingTop: "18px",
  },
  "& .MuiSelect-icon": {
    marginLeft: "20px",
    right: "5px",
  },
};
interface KPIProps {
  kpiData: {
    WeightageData: Record<string, string>;
    WeeklyData: Record<string, string>;
    KpiData: Array<Record<string, any>>;
  };
}
interface UserData {
  user_Id: string;
  role: string;
  [key: string]: any;
}

interface LeadershipTableProps {
  userData: UserData | null;
}
const LeadershipTable: React.FC<LeadershipTableProps> = ({ userData }) => {
  console.log('User Data:', userData);
const getWeekLogic = (date = new Date()) => {
  const day = date.getDate();
  let currentWeek = 1;
  let dropdownOptions: number[] = [];
  let monthDate = new Date(date); 

  if (day >= 1 && day <= 7) {
    currentWeek = 4;
    dropdownOptions = [1, 2, 3, 4];
    monthDate.setMonth(monthDate.getMonth() - 1); // use previous month
  } else if (day >= 8 && day <= 14) {
    currentWeek = 1;
    dropdownOptions = [1];
    // monthDate = current
  } else if (day >= 15 && day <= 21) {
    currentWeek = 2;
    dropdownOptions = [1, 2];
  } else {
    currentWeek = 3;
    dropdownOptions = [1, 2, 3];
  }

  const month = monthDate.toLocaleString('default', { month: 'long' });

  return {
    currentWeek,      // default week to select
    dropdownOptions,  // weeks to show in <Select>
    month             // month to send in payload
  };
};
   const { updateSalesUnit, setKpiData, setLoading } = useSalesContext();
  const [alignment, setAlignment] = useState('slm');
  const { currentWeek, dropdownOptions, month } = getWeekLogic();
  const [week, setWeek] = useState(currentWeek);
  const [weekOptions, setWeekOptions] = useState(dropdownOptions);
  const [selectedMonth, setSelectedMonth] = useState(month);
  const [tableData, setTableData] = useState<{
    DateRange: any; WeightageData?: any; WeeklyData?: any; KpiData?: any[] 
}>({});
  
  
  const handleAlignment = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
    if (newAlignment !== null) setAlignment(newAlignment);
  };
const columns = [ "NAME","SCORE" ,"UNIQUE DR. MET","UNIQUE DOCTOR MET A+/A",  "DOCTOR CALL AVG", "FREQ VIST COMPLIANCE %","Region Sales Growth %", "%Ach"];

 useEffect(() => {
  if (!userData?.userId) return; // early exit if userId is not ready

  setLoading(true); 

  fetch(`${API_BASE_URL}Leaderboard/SLMKPIDashboard`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId: userData.userId,
      week,
      role: userData.user_Role, 
      month: selectedMonth,
    }),
  })
    .then(res => res.json())
    .then(data => {
      if (data) {
        setLoading(false);
        setKpiData(data);
        setTableData(data);
        console.log('KPI Data fetched successfully:', data);
      }
    })
    .catch(error => {
      setLoading(true);
      console.error('Failed to fetch KPI Data', error);
    });
}, [alignment, week, userData]); // 👈 Add userData as dependency

 const { WeightageData, WeeklyData, KpiData } = tableData;
const sanitize = (value: number | string, precision: number = 0): string | number => {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "--";
  const cleanNum = num < 0 ? 0 : num;
  return cleanNum.toFixed(precision);
};

  return (
    <Box sx={{ p: 2 }} className="table-Leadership-container">

      <Box className="Leadership-sections" sx={{ display: 'flex', gap: 2 }}>
        <Box className="section">
        <Typography className="Leadership-title" sx={{ fontSize: "14px" }}>
          Date Range
          </Typography>
        
        </Box>
  <Box className="section">
        
        
        </Box>
      
        <Box className="section">
        <FormControl fullWidth sx={{ width: '200px', height: '30px !important' }}>
  {tableData?.DateRange
    ? `${new Date(tableData.DateRange.StartDate).toLocaleDateString('en-GB', {
        day: '2-digit', month: 'short', year: '2-digit'
      })} to ${new Date(tableData.DateRange.EndDate).toLocaleDateString('en-GB', {
        day: '2-digit', month: 'short', year: '2-digit'
      })}`
    : 'Loading...'}
</FormControl>

        </Box>
        <Box className="section">
          </Box>
        <Box >
             <Typography className="section-label-3">Week</Typography>
          </Box>
         <Box className="section">
            <FormControl sx={{ width: '200px', height: '30px !important' }}>
                <Select
                  value={week}
                  onChange={(e) => setWeek(Number(e.target.value))}
                  sx={selectStyles}
                            size="medium"
                >
                  {weekOptions.map(w => (
                    <MenuItem key={w} value={w}>Week {w}</MenuItem>
                  ))}
                </Select>
              </FormControl>
        </Box>
      </Box>

   <TableContainer component={Paper} className="Leadership-table-container">
  <Table stickyHeader size="small">
    <TableHead className="Leadership-table-head">
      <TableRow>
{columns.map((heading, i) => (
          <TableCell key={i} className="Leadership-table-header" align="center">{heading}</TableCell>
        ))}
      </TableRow>
    </TableHead>

    <TableBody className="Leadership-table-body">
      {tableData && tableData.WeeklyData && tableData.WeightageData && tableData.KpiData ? (
       <>
  {[tableData.WeeklyData, tableData.WeightageData].map((row, index) => (
    <TableRow
      key={`static-${index}`}
      style={{
        borderBottom: index === 0 ? 'none' : undefined,
        height: 48,
      }}
    >
      <TableCell align="center" sx={{ padding: '12px', fontSize: '13px' }}><span>  {row.Name || `Vacant_${userData?.user_Location || ''}`}</span>
</TableCell>
      <TableCell align="center" sx={{ padding: '12px' }}>--</TableCell>
      <TableCell align="center" sx={{ padding: '12px' }}>{sanitize(row.Unique_Dr_Met )}</TableCell>
      <TableCell align="center" sx={{ padding: '12px' }}>{sanitize (row.Unique_Dr_Met_APlus_A)}</TableCell>
      <TableCell align="center" sx={{ padding: '12px' }}>{sanitize( row.Dr_Call_Avg , 1)}</TableCell>
      <TableCell align="center" sx={{ padding: '12px' }}>{sanitize(row.Freq_Visit_Comp_Per , 2)}</TableCell>
      <TableCell align="center" sx={{ padding: '12px' }}>{sanitize(row.Region_Sales_Growth_Per , 2)}</TableCell>
      <TableCell align="center" sx={{ padding: '12px' }}>{sanitize(row.Per_Ach, 2)}</TableCell>
    </TableRow>
  ))}

  <TableRow>
    <TableCell colSpan={8} sx={{ padding: 0 }}>
      <Box sx={{ height: '2px', backgroundColor: '#297F9D' }} />
    </TableCell>
  </TableRow>

  {tableData.KpiData.map((row: any, idx: number) => (
    
    <TableRow key={`kpi-${idx}`} className="Leadership-table-row">
           <TableCell className="Leadership-table-cell" align="center">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center', // optional, for centering inside the cell
            gap: 1, // spacing between box and text
          }}
        >
          <Box
          />
          <span>  {row.Name || `Vacant_${userData?.user_Location || ''}`}</span>
        </Box>
      </TableCell>
         <TableCell className="Leadership-table-cell" align="center">
           <Box
             sx={{
               width: 30,
               height: 30,
               borderRadius: '0px',
               margin: 'auto',
             backgroundColor:
  row.Score >= 90 ? '#4caf50' :    // Green
  row.Score >= 70 ? '#ffeb3b' :    // Yellow
  '#f44336',                       // Red

               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center',
               color: '#fff',
               fontWeight: 'bold',
               fontSize: '12px', // Adjust font size if needed
               lineHeight: 1,     // Prevent vertical offset
               textAlign: 'center',
             }}
           >
             {row.Score}
           </Box>
         </TableCell>
      <TableCell className="Leadership-table-cell" align="center">{sanitize(row.Unique_Dr_Met)}</TableCell>
      <TableCell className="Leadership-table-cell" align="center">{sanitize(row.Unique_Dr_Met_APlus_A)}</TableCell>
      <TableCell className="Leadership-table-cell" align="center">{sanitize(row.Dr_Call_Avg , 1)}</TableCell>
      <TableCell className="Leadership-table-cell" align="center">{sanitize(row.Freq_Visit_Comp_Per , 2)}</TableCell>
      <TableCell className="Leadership-table-cell" align="center">{sanitize(row.Region_Sales_Growth_Per ,2)}</TableCell>
      <TableCell className="Leadership-table-cell" align="center">{sanitize(row.Per_Ach , 2)}</TableCell>
    </TableRow>
  ))}
</>

      ) : (
        <TableRow>
          <TableCell colSpan={7} align="center">No Data Available</TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
</TableContainer>

    </Box>
  );
};

export default LeadershipTable;

